import { render, staticRenderFns } from "./ArtworkEmbed.vue?vue&type=template&id=2185bff3&"
import script from "./ArtworkEmbed.vue?vue&type=script&lang=js&"
export * from "./ArtworkEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports